export type ToggleItem<T extends string> = {
	label: string;
	value: T;
};

type ToggleProps<T extends string> = {
	items: ReadonlyArray<ToggleItem<T>>;
	onClick: (value: T) => void;
	value: T;
};

const Toggle = <T extends string>({
	items,
	onClick,
	value,
}: ToggleProps<T>) => {
	return (
		<div className="mx-5 my-2 flex max-w-md items-center gap-2 rounded-lg bg-mantang-gray-100 p-1 font-medium text-mantang-gray-700 text-sm">
			{items?.map((item) => (
				<button
					type="button"
					className={`flex h-9 flex-1 cursor-pointer items-center justify-center transition-colors ${item.value === value ? 'rounded-lg bg-white text-mantang-gray-900' : ''}`}
					key={item.value}
					onClick={() => onClick(item.value)}
				>
					{item.label}
				</button>
			))}
		</div>
	);
};

export default Toggle;
